<div class="main-container">
    <div class="stepper-container">
        <lgv-pre-approval-stepper [loanInfo]="selectedLoanApp.loanInfo"></lgv-pre-approval-stepper>
    </div>
</div>